import * as D from "react";
import { useState as H, useEffect as gt, forwardRef as F } from "react";
import { j as e } from "../../jsx-runtime-CZlWR0BA.js";
import { H as d, C as O } from "../../styled-components.browser.esm-cBExeaUK.js";
import { P as U } from "../../product-counter-DjRJC2RH.js";
import { a as _ } from "../../utils-CUYMSp7x.js";
import { I as ct } from "../../icon-W7HiZyiU.js";
var V = /* @__PURE__ */ new Map(), L = /* @__PURE__ */ new WeakMap(), ot = 0, ft = void 0;
function xt(t) {
  return t ? (L.has(t) || (ot += 1, L.set(t, ot.toString())), L.get(t)) : "0";
}
function pt(t) {
  return Object.keys(t).sort().filter(
    (r) => t[r] !== void 0
  ).map((r) => `${r}_${r === "root" ? xt(t.root) : t[r]}`).toString();
}
function St(t) {
  const r = pt(t);
  let i = V.get(r);
  if (!i) {
    const n = /* @__PURE__ */ new Map();
    let o;
    const a = new IntersectionObserver((s) => {
      s.forEach((c) => {
        var l;
        const g = c.isIntersecting && o.some((m) => c.intersectionRatio >= m);
        t.trackVisibility && typeof c.isVisible > "u" && (c.isVisible = g), (l = n.get(c.target)) == null || l.forEach((m) => {
          m(g, c);
        });
      });
    }, t);
    o = a.thresholds || (Array.isArray(t.threshold) ? t.threshold : [t.threshold || 0]), i = {
      id: r,
      observer: a,
      elements: n
    }, V.set(r, i);
  }
  return i;
}
function yt(t, r, i = {}, n = ft) {
  if (typeof window.IntersectionObserver > "u" && n !== void 0) {
    const l = t.getBoundingClientRect();
    return r(n, {
      isIntersecting: n,
      target: t,
      intersectionRatio: typeof i.threshold == "number" ? i.threshold : 0,
      time: 0,
      boundingClientRect: l,
      intersectionRect: l,
      rootBounds: l
    }), () => {
    };
  }
  const { id: o, observer: a, elements: s } = St(i), c = s.get(t) || [];
  return s.has(t) || s.set(t, c), c.push(r), a.observe(t), function() {
    c.splice(c.indexOf(r), 1), c.length === 0 && (s.delete(t), a.unobserve(t)), s.size === 0 && (a.disconnect(), V.delete(o));
  };
}
function dt({
  threshold: t,
  delay: r,
  trackVisibility: i,
  rootMargin: n,
  root: o,
  triggerOnce: a,
  skip: s,
  initialInView: c,
  fallbackInView: l,
  onChange: g
} = {}) {
  var m;
  const [f, P] = D.useState(null), y = D.useRef(), [x, j] = D.useState({
    inView: !!c,
    entry: void 0
  });
  y.current = g, D.useEffect(
    () => {
      if (s || !f)
        return;
      let u;
      return u = yt(
        f,
        (b, v) => {
          j({
            inView: b,
            entry: v
          }), y.current && y.current(b, v), v.isIntersecting && a && u && (u(), u = void 0);
        },
        {
          root: o,
          rootMargin: n,
          threshold: t,
          // @ts-ignore
          trackVisibility: i,
          // @ts-ignore
          delay: r
        },
        l
      ), () => {
        u && u();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(t) ? t.toString() : t,
      f,
      o,
      n,
      a,
      s,
      i,
      l,
      r
    ]
  );
  const p = (m = x.entry) == null ? void 0 : m.target, $ = D.useRef();
  !f && p && !a && !s && $.current !== p && ($.current = p, j({
    inView: !!c,
    entry: void 0
  }));
  const h = [P, x.inView, x.entry];
  return h.ref = h[0], h.inView = h[1], h.entry = h[2], h;
}
const $t = d.img`
  ${(t) => t.variant !== "horizontal" && `margin: ${t.theme.spacingStackMicro}`};
  mix-blend-mode: ${(t) => t.active ? "darken" : "multiply"};
  transition: transform 0.25s ease;
  transform: ${(t) => t.counterExpanded ? "scale(0.652) translateY(calc(-37.5% + 16px))" : "scale(1)"};
  ${(t) => t.variant === "simplified" && "overflow: clip"};
  opacity: ${(t) => t.active ? "100%" : "50%"};
  object-fit: contain;
  object-position: center;
  width: 100%;
  height: 100%;
`, X = (t) => {
  const { active: r = !0, counterExpanded: i = !1, defaultImageSrc: n, imageSrc: o, variant: a = "default", ...s } = t, [c, l] = H(o), g = () => l(n), { ref: m, inView: f } = dt({
    triggerOnce: !0
  });
  return /* @__PURE__ */ e.jsx(
    $t,
    {
      active: r,
      "data-testid": "product-image",
      src: f ? c ?? n : n,
      variant: a,
      counterExpanded: i,
      onError: g,
      ref: m,
      ...s
    }
  );
}, bt = d.div`
  color: ${(t) => t.theme.colorSupportPositiveMedium};
  display: flex;
  align-items: center;

  & p {
    font-size: ${(t) => t.theme.fontSizeNano};
    margin: 0 0 0 ${(t) => t.theme.spacingInlineQuarckRem};
  }
`, q = (t) => {
  const {
    infoLine: { icon: r, text: i }
  } = t;
  return /* @__PURE__ */ e.jsxs(bt, { "data-testid": "info-line", children: [
    r && /* @__PURE__ */ e.jsx(ct, { name: r, size: "sm", "data-testid": "info-icon" }),
    /* @__PURE__ */ e.jsx("p", { children: i })
  ] });
}, vt = d.div`
  color: ${(t) => t.theme.colorSupportNegativeMedium};
  display: flex;
  & p {
    font-size: ${(t) => t.theme.fontSizeNano};
    margin: 0 0 0 ${(t) => t.theme.spacingInlineQuarckRem};
  }
`, lt = (t) => {
  const { children: r } = t;
  return /* @__PURE__ */ e.jsxs(vt, { "data-testid": "max-sale-qty-alert", children: [
    /* @__PURE__ */ e.jsx(ct, { name: "info", size: "sm", "data-testid": "info-icon" }),
    /* @__PURE__ */ e.jsx("p", { children: r })
  ] });
}, Ct = (t, r) => r ? r > t ? t : r : t, st = (t, r = 2) => {
  if (t == null)
    return "0.00";
  const i = 10 ** r, n = Math.round(t * i) / i, o = n == null ? void 0 : n.toFixed(r).split(".");
  return o[0] = o[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), o.join(".");
}, jt = d.div`
  width: 100%;
  ${(t) => t.variant === "horizontal" ? { display: "flex", "flex-direction": "column" } : { display: "grid", "grid-template-columns": "auto", "justify-content": "flex-start" }};
`, Pt = d.div`
  display: ${(t) => t.variant === "horizontal" ? "contents" : "block"};
`, kt = d.span`
  display: 'inline';
  color: ${(t) => t.hasDiscount ? t.theme.colorSupportPositiveMedium : t.theme.colorNeutralDarkest};
  font-size: ${(t) => t.variant === "horizontal" ? t.theme.fontSizeNano : t.theme.fontSizeXxxs};
  font-family: ${(t) => t.theme.fontFamilyBold};
  font-weight: ${(t) => t.theme.fontWeightBold};
  line-height: ${(t) => t.variant === "horizontal" ? t.theme.lineHeightConfy : t.theme.lineHeightFair};
  margin-right: ${(t) => t.theme.spacingInlineNanoRem};
`, zt = d.span`
  display: inline;
  color: ${(t) => t.theme.colorNeutralDark};
  font-size: ${(t) => t.theme.fontSizeQuarck};
  font-style: normal;
  font-weight: ${(t) => t.theme.fontWeightRegular};
  line-height: ${(t) => t.theme.lineHeightFair};
  text-decoration-line: line-through;
`, Y = (t) => {
  const { currencySymbol: r, finalPrice: i, hasDiscount: n, regularPrice: o, variant: a = "default" } = t;
  return /* @__PURE__ */ e.jsx(jt, { variant: a, children: /* @__PURE__ */ e.jsxs(Pt, { variant: a, children: [
    /* @__PURE__ */ e.jsxs(kt, { hasDiscount: n, variant: a, "data-testid": "final-price", children: [
      r,
      " ",
      st(i)
    ] }),
    n && /* @__PURE__ */ e.jsxs(zt, { "data-testid": "regular-price", children: [
      r,
      " ",
      st(o)
    ] })
  ] }) });
};
var A = /* @__PURE__ */ ((t) => (t.POSITIVE = "positive", t.NEGATIVE = "negative", t.NEUTRAL = "neutral", t))(A || {});
const wt = d.div`
  opacity: ${(t) => !t.active && "50%"};
  ${(t) => t.variant === "horizontal" ? {
  left: 0,
  top: 0,
  "text-align": "left",
  position: "relative",
  "z-index": "1"
} : {
  left: 0,
  top: 0,
  "text-align": "left",
  position: "absolute",
  "z-index": "1"
}}
`, Rt = d.div`
  display: flex;
  flex-direction: ${(t) => t.variant === "horizontal" ? "row" : "column"};
  align-items: normal;
`, Qt = d.label`
  z-index: 1;
  border-radius: ${(t) => t.variant === "horizontal" ? t.theme.borderRadiusSm : "0"};
  font-size: 0.65rem;
  background-color: ${(t) => {
  switch (t.tag.type) {
    case A.POSITIVE:
      return t.theme.colorSupportPositiveMedium;
    case A.NEGATIVE:
      return t.theme.colorSupportNegativeMedium;
    case A.NEUTRAL:
      return t.theme.colorNeutralDark;
    default:
      return t.theme.colorNeutralLightest;
  }
}};
  align-items: center;
  color: ${(t) => t.theme.colorNeutralLightest};
  display: inline-flex;
  font-family: ${(t) => t.theme.fontFamilyRegular};
  font-weight: ${(t) => t.theme.fontWeightRegular};
  justify-content: center;
  line-height: 0.625rem;
  margin: 0;
  margin-right: ${(t) => t.variant === "horizontal" ? t.theme.spacingInlineQuarckRem : "0"};
  margin-bottom: 0.125rem;
  min-height: 1.25rem;
  padding: 0.275rem 0.375rem;
  text-align: ${(t) => t.tag.align};
  white-space: pre-wrap;
  max-width: ${(t) => t.variant === "horizontal" ? "10rem" : "5rem"};

  &:last-child {
    ${(t) => {
  if (t.variant !== "horizontal")
    return { "border-bottom-right-radius": t.theme.borderRadiusMd };
}}
  }

  &:first-child {
    ${(t) => {
  if (t.variant !== "horizontal")
    return { "border-top-left-radius": t.theme.borderRadiusMd };
}}
  }
`, Nt = (t) => {
  const { tag: r } = t, { labelText: i } = r;
  return /* @__PURE__ */ e.jsx(Qt, { ...t, "aria-label": i, children: i });
}, G = ({ enoughStock: t, tags: r, variant: i = "default", active: n = !0, ...o }) => {
  const a = t ? [] : [{ type: A.NEUTRAL, labelText: "Sin stock" }], s = [...r, ...a];
  return /* @__PURE__ */ e.jsx(wt, { active: n, ...o, variant: i, children: /* @__PURE__ */ e.jsx(Rt, { variant: i, children: s.map((c, l) => /* @__PURE__ */ e.jsx(Nt, { tag: c, variant: i }, `tag-${l}${c.labelText}`)) }) });
};
var E = /* @__PURE__ */ ((t) => (t.MAXIMUM_SALE_QUANTITY = "maximumSaleQuantity", t.STOCK = "stock", t.NONE = "", t))(E || {});
const Mt = (t) => {
  const { maximumSaleQuantity: r, minimumSaleQuantity: i = 1, quantity: n, stock: o } = t, [a, s] = H(E.NONE);
  return gt(() => {
    r && r === n && r <= o ? s(E.MAXIMUM_SALE_QUANTITY) : o >= i && o === n ? s(E.STOCK) : s(E.NONE);
  }, [r, i, n, o]), {
    alertMaximumReached: a,
    maxPossibleSaleQty: Ct(o, r)
  };
}, K = (t, r) => O`
  word-wrap: break-word;
  background: ${(i) => i.theme.colorNeutralLightest};
  background-clip: content-box;
  display: grid;
  position: relative;
  width: 13rem;
  row-gap: ${(i) => i.theme.spacingStackNanoRem};
  ${() => {
  if (!r)
    return {
      "pointer-events": "none"
    };
  if (!t)
    return {
      "-webkit-filter": "grayscale(1)",
      filter: "grayscale(1)",
      "pointer-events": "none"
    };
}}
  &:hover {
    box-shadow: ${(i) => t ? i.theme.shadowDown01 : "none"};
  }
`, J = O`
  align-items: center;
  background: ${(t) => t.theme.colorNeutralLight};
  border-radius: ${(t) => t.theme.borderRadiusMd};
  display: flex;
  justify-content: center;
  position: relative;
`, Z = O`
  display: grid;
  grid-template-rows: auto;
  margin-bottom: auto;
`, tt = d.p`
  color: ${(t) => t.theme.colorNeutralDarkest};
  font-family: ${(t) => t.theme.fontFamilyBold};
  font-size: ${(t) => t.theme.fontSizeNano};
  line-height: ${(t) => t.theme.lineHeightFair};
  margin-bottom: ${(t) => t.theme.spacingStackQuarckRem};
  font-weight: ${(t) => t.theme.fontWeightBold};
  word-break: break-word;
`, et = d.p`
  color: ${(t) => t.theme.colorNeutralDarkest};
  font-family: ${(t) => t.theme.fontFamilyRegular};
  font-size: ${(t) => t.theme.fontSizeQuarck};
  line-height: ${(t) => t.theme.lineHeightFair};
  margin-bottom: ${(t) => t.theme.spacingStackNanoRem};
`, it = d.div`
  opacity: ${(t) => !t.active && "50%"};
`, It = d.div`
  display: grid;
  grid-template-columns: 1fr 140px;
  margin-bottom: auto;
  justify-content: flex-start;
`, rt = O`
  background-color: ${(t) => t.theme.colorSupportWarningLightest};
  border: ${(t) => t.theme.borderWidthHairline} solid ${(t) => t.theme.colorSupportWarningMedium};
  border-radius: ${(t) => t.theme.borderRadiusSm};
  color: ${(t) => t.theme.colorSupportWarningDark};
  font-size: ${(t) => t.theme.fontSizeQuarck};
  line-height: ${(t) => t.theme.lineHeightTight};
  padding: ${(t) => t.theme.spacingInsetNanoRem} 0;
  position: absolute;
  text-align: center;
  width: 90%;
  display: block;
  z-index: 1;
`, nt = d.p`
  color: ${(t) => t.theme.colorSupportWarningDark};
  font-size: ${(t) => t.theme.fontSizeQuarck};
  margin-bottom: ${(t) => t.theme.spacingStackQuarckRem};
`, at = d.div`
  color: ${(t) => t.theme.colorSupportNegativeMedium};
  font-weight: ${(t) => t.theme.fontWeightSemibold};
  font-size: 0.875rem;
  text-align: center;
`, Tt = d.article`
  ${(t) => K(t.hasStock, t.active)}

  padding:  ${(t) => t.theme.spacingInsetSmRem};
  transition: box-shadow 0.2s ease-in;
  height: 22rem;
  border-radius: ${(t) => t.theme.borderRadiusLg};
  grid-template-rows: auto 1fr;
`, Dt = d.div`
  ${J}

  height: 11rem;
  & img {
    max-width: 8rem;
    max-height: 8rem;
  }
`, Et = d.div`
  ${Z}
`, At = d.div`
  ${rt}
`, ut = F((t, r) => {
  const {
    active: i,
    alertMaximumReached: n,
    clickingDelay: o,
    defaultImageSrc: a,
    infoLine: s,
    isLoading: c,
    typingDelay: l,
    maxPossibleSaleQty: g,
    maximumSaleQuantityText: m,
    minimumSaleQuantityText: f,
    onAbort: P,
    onCardClick: y,
    onChangeQuantity: x,
    outOfStockText: j,
    product: p,
    quantity: $,
    tags: h,
    ...u
  } = t, {
    currencySymbol: b,
    finalPrice: v,
    hasDiscount: k,
    image: C,
    minimumSaleQuantity: S = 1,
    title: z,
    subtitle: w,
    regularPrice: R,
    stock: Q
  } = p, [B, W] = H(!1), N = "default", M = Q >= S, I = { active: i, hasStock: M };
  return /* @__PURE__ */ e.jsxs(Tt, { ref: r, ...I, "data-testid": "container", ...u, ..._(y), children: [
    /* @__PURE__ */ e.jsxs(Dt, { ...I, role: "button", children: [
      /* @__PURE__ */ e.jsx(G, { active: i, enoughStock: Q >= S, tags: h }),
      n === "stock" && /* @__PURE__ */ e.jsx(At, { "data-testid": "max-stock-alert", children: j }),
      /* @__PURE__ */ e.jsx(
        X,
        {
          active: i,
          alt: z,
          imageSrc: C,
          counterExpanded: B,
          defaultImageSrc: a,
          width: "128",
          height: "128"
        },
        C
      ),
      /* @__PURE__ */ e.jsx(
        U,
        {
          active: M && i,
          clickingDelay: o,
          expandCounter: W,
          isLoading: c,
          maxPossibleSaleQty: g,
          minimumSaleQuantity: S,
          onAbort: P,
          onInputChange: (T) => x(T, T < $),
          quantity: $,
          size: "sm",
          style: { position: "absolute", right: "0", bottom: "0" },
          typingDelay: l,
          variant: N
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs(Et, { children: [
      /* @__PURE__ */ e.jsxs(it, { active: i, children: [
        n === "maximumSaleQuantity" && /* @__PURE__ */ e.jsx(lt, { children: m }),
        s && /* @__PURE__ */ e.jsx(q, { infoLine: s }),
        /* @__PURE__ */ e.jsx(tt, { children: z }),
        /* @__PURE__ */ e.jsx(et, { children: w }),
        S > 1 && /* @__PURE__ */ e.jsx(nt, { children: f })
      ] }),
      i ? /* @__PURE__ */ e.jsx(
        Y,
        {
          currencySymbol: b,
          finalPrice: v,
          hasDiscount: k,
          regularPrice: R
        }
      ) : /* @__PURE__ */ e.jsx(at, { children: "No se puede comprar" })
    ] })
  ] });
});
ut.displayName = "DefaultProductCard";
const Lt = ut, Ht = d.article`
  ${(t) => K(t.hasStock, t.active)}

  padding: ${(t) => t.theme.spacingInsetXsRem};
  transition: none 0s ease;
  border-radius: ${(t) => t.theme.borderRadiusMd};
  max-width: 100%;
  min-width: 20rem;
  grid-template-rows: auto;
  column-gap: ${(t) => t.theme.spacingInsetXsRem};
  grid-template-columns: 64px 1fr;
  margin: -${(t) => t.theme.spacingInsetXsRem};
`, Ot = d.div`
  ${J}

  & img {
    width: 4rem;
    max-height: 4rem;
    transform: none;
  }
`, Bt = d.div`
  ${Z}
  gap: ${(t) => t.theme.spacingStackQuarckRem};
  & input {
    max-width: 2.75rem;
  }
`, Wt = d.div`
  ${rt}
  bottom: ${(t) => t.theme.spacingStackNanoRem};
`, mt = F((t, r) => {
  const {
    active: i,
    alertMaximumReached: n,
    clickingDelay: o,
    defaultImageSrc: a,
    infoLine: s,
    isLoading: c,
    maxPossibleSaleQty: l,
    maximumSaleQuantityText: g,
    minimumSaleQuantityText: m,
    onAbort: f,
    onCardClick: P,
    onChangeQuantity: y,
    outOfStockText: x,
    product: j,
    quantity: p,
    tags: $,
    typingDelay: h,
    ...u
  } = t, {
    currencySymbol: b,
    finalPrice: v,
    hasDiscount: k,
    image: C,
    minimumSaleQuantity: S = 1,
    title: z,
    subtitle: w,
    regularPrice: R,
    stock: Q
  } = j, [B, W] = H(!1), N = "horizontal", M = Q >= S, I = { active: i, hasStock: M };
  return /* @__PURE__ */ e.jsxs(Ht, { ref: r, ...I, "data-testid": "container", ...u, ..._(P), children: [
    /* @__PURE__ */ e.jsxs(Ot, { ...I, role: "button", children: [
      n === "stock" && /* @__PURE__ */ e.jsx(Wt, { "data-testid": "max-stock-alert", children: x }),
      /* @__PURE__ */ e.jsx(
        X,
        {
          active: i,
          alt: z,
          imageSrc: C,
          counterExpanded: B,
          defaultImageSrc: a
        },
        C
      )
    ] }),
    /* @__PURE__ */ e.jsxs(Bt, { children: [
      /* @__PURE__ */ e.jsx(G, { active: i, enoughStock: Q >= S, tags: $, variant: N }),
      /* @__PURE__ */ e.jsxs(it, { active: i, children: [
        n === "maximumSaleQuantity" && /* @__PURE__ */ e.jsx(lt, { children: g }),
        s && /* @__PURE__ */ e.jsx(q, { infoLine: s }),
        /* @__PURE__ */ e.jsx(tt, { children: z }),
        /* @__PURE__ */ e.jsx(et, { children: w }),
        S > 1 && /* @__PURE__ */ e.jsx(nt, { children: m })
      ] }),
      /* @__PURE__ */ e.jsxs(It, { children: [
        i && /* @__PURE__ */ e.jsx(
          Y,
          {
            currencySymbol: b,
            finalPrice: v,
            hasDiscount: k,
            regularPrice: R,
            variant: N
          }
        ),
        /* @__PURE__ */ e.jsx(
          U,
          {
            active: M && i,
            clickingDelay: o,
            expandCounter: W,
            isLoading: c,
            maxPossibleSaleQty: l,
            minimumSaleQuantity: S,
            onAbort: f,
            onInputChange: (T) => y(T, T < p),
            quantity: p,
            size: "sm",
            typingDelay: h,
            variant: N
          }
        )
      ] }),
      !i && /* @__PURE__ */ e.jsx(at, { children: "No se puede comprar" })
    ] })
  ] });
});
mt.displayName = "HorizontalProductCard";
const Vt = mt, Ft = d.article`
  ${(t) => K(t.hasStock, t.active)}
  padding: 0.75rem;
  transition: none 0s ease;
  min-height: 14rem;
  border-radius: ${(t) => t.theme.borderRadiusMd};
  max-width: 13rem;
  grid-template-rows: auto 1fr;
`, Ut = d.div`
  ${J}
  height: 5rem;
  overflow: hidden;

  & img {
    width: auto;
    max-height: 100%;
  }
`, _t = d.div`
  ${Z}
`;
d.div`
  ${rt}
`;
const ht = F((t, r) => {
  const {
    active: i,
    clickingDelay: n,
    defaultImageSrc: o,
    infoLine: a,
    isLoading: s,
    minimumSaleQuantityText: c,
    onAbort: l,
    onCardClick: g,
    onChangeQuantity: m,
    product: f,
    quantity: P,
    tags: y,
    ...x
  } = t, {
    currencySymbol: j,
    finalPrice: p,
    hasDiscount: $,
    image: h,
    minimumSaleQuantity: u = 1,
    title: b,
    subtitle: v,
    regularPrice: k,
    stock: C
  } = f, S = "simplified", z = C >= u, w = { active: i, hasStock: z };
  return /* @__PURE__ */ e.jsxs(Ft, { ref: r, ...w, ...x, ..._(g), children: [
    /* @__PURE__ */ e.jsxs(Ut, { ...w, role: "button", children: [
      /* @__PURE__ */ e.jsx(G, { active: i, enoughStock: C >= u, tags: y }),
      /* @__PURE__ */ e.jsx(
        X,
        {
          active: i,
          alt: b,
          imageSrc: h,
          variant: S,
          counterExpanded: !1,
          defaultImageSrc: o
        },
        h
      ),
      /* @__PURE__ */ e.jsx(
        U,
        {
          active: z && i,
          clickingDelay: n,
          isLoading: s,
          maxPossibleSaleQty: C,
          minimumSaleQuantity: u,
          onAbort: l,
          onInputChange: (R) => m(R, !1),
          quantity: P,
          size: "xs",
          style: { position: "absolute", right: "0", bottom: "0" },
          variant: S
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs(_t, { children: [
      /* @__PURE__ */ e.jsxs(it, { active: i, children: [
        a && /* @__PURE__ */ e.jsx(q, { infoLine: a }),
        /* @__PURE__ */ e.jsx(tt, { children: b }),
        /* @__PURE__ */ e.jsx(et, { children: v }),
        u > 1 && /* @__PURE__ */ e.jsx(nt, { children: c })
      ] }),
      i ? /* @__PURE__ */ e.jsx(
        Y,
        {
          currencySymbol: j,
          finalPrice: p,
          hasDiscount: $,
          regularPrice: k
        }
      ) : /* @__PURE__ */ e.jsx(at, { children: "No se puede comprar" })
    ] })
  ] });
});
ht.displayName = "SimplifiedProductCard";
const Xt = ht, qt = (t) => {
  const {
    active: r = !0,
    infoLine: i = { text: "", icon: "" },
    isLoading: n,
    maximumSaleQuantityText: o = "Máximo de productos",
    product: a,
    minimumSaleQuantityText: s = `Mínimo ${a.minimumSaleQuantity} unidades`,
    quantity: c,
    onChangeQuantity: l,
    outOfStockText: g = `Máximo ${a.stock} unidades`,
    variant: m = "default",
    isObservable: f = !1,
    triggerOnce: P = !1,
    threshold: y = 0,
    onVisible: x,
    ...j
  } = t, { maximumSaleQuantity: p, minimumSaleQuantity: $ = 1, stock: h } = a, { ref: u } = dt({
    onChange: (C) => x && x(C),
    skip: !f,
    triggerOnce: P,
    threshold: y
  }), { alertMaximumReached: b, maxPossibleSaleQty: v } = Mt({
    quantity: c,
    stock: h,
    maximumSaleQuantity: p,
    minimumSaleQuantity: $
  }), k = {
    active: r,
    infoLine: i,
    isLoading: n,
    product: a,
    alertMaximumReached: b,
    maxPossibleSaleQty: v,
    maximumSaleQuantityText: o,
    minimumSaleQuantityText: s,
    outOfStockText: g,
    quantity: c,
    onChangeQuantity: l,
    ref: u,
    ...j
  };
  switch (m) {
    case "simplified":
      return /* @__PURE__ */ e.jsx(Xt, { ...k });
    case "horizontal":
      return /* @__PURE__ */ e.jsx(Vt, { ...k });
    default:
      return /* @__PURE__ */ e.jsx(Lt, { ...k });
  }
}, ee = qt;
export {
  Lt as DefaultProductCard,
  E as EMaximumAlertType,
  A as EProductCardTagType,
  Vt as HorizontalProductCard,
  ee as ProductCard,
  Xt as SimplifiedProductCard,
  Ct as getMaximumPossibleSaleQuantity,
  Mt as useMaximumPossibleQuantity
};
